import moment from 'moment';

const diffDatesParams = {
  dateFrom: moment(),
  dateTo: moment(),
  absolute: false,
  measure: 'days', // years, months, weeks, days, hours, minutes
  fromFormat: 'YYYY-MM-DD',
};

export const diffDates = (params = diffDatesParams) => {
  params = { ...diffDatesParams, ...params };

  let from = moment(params.dateFrom, params.fromFormat);
  let to = moment(params.dateTo, params.fromFormat);

  let diff = to.diff(from, params.measure);

  return params.absolute ? Math.abs(diff) : diff;
};

// return the count of milliseconds until to specific time of day
export const timeUntil = (hour = 0, mins = 0, secs = 0, millis = 0) => {
  const oneDayMilliSeconds = 24 * 60 * 60 * 1000;
  const now = new Date();
  const targetedTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, mins, secs, millis);

  const millisTill = targetedTime - now;

  if (millisTill < 0) {
    return millisTill + oneDayMilliSeconds;
  }

  return millisTill;
};
